"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsHtml = void 0;
var containsHtml = function (str) { return /<[a-z][\s\S]*>/i.test(str); };
exports.containsHtml = containsHtml;
